import z from 'zod'

export const getStorageKey = (userId: number, companyId: number) => {
  return `@atlas:v1:maps:last-selection:user:${userId}:company:${companyId}`
}

const mapsSelectionSchema = z.object({
  project_id: z.number(),
  region_id: z.number(),
})

export type MapsSelection = z.infer<typeof mapsSelectionSchema>

export const getLastSelection = (
  userId: number,
  companyId: number,
): MapsSelection | null => {
  try {
    const raw = localStorage.getItem(getStorageKey(userId, companyId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return mapsSelectionSchema.parse(parsed)
  } catch {
    return null
  }
}

export const saveSelection = (
  newSelection: MapsSelection,
  userId: number,
  companyId: number,
) => {
  localStorage.setItem(
    getStorageKey(userId, companyId),
    JSON.stringify(newSelection),
  )
}
